var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'usertype-new',
  created () {
    this.getQuestions()
  },
  data () {
    return {
      canValidate: true,
      savingFlag: false,
      getQuestionEnd: false,
      contentCount: 0,
      questions: '',
      user_type: {
        user_type_name: null,
        default_user_authority: null,
        user_type_priority: null,
        employee_flg: null,
        business_type_content: null,
        question_id: null
      }
    }
  },
  computed: {
    validation: function () {
      var v = {
        user_type_name: !!this.user_type.user_type_name,
        default_user_authority: [1, 2, 3, 4, 5].indexOf(this.user_type.default_user_authority) >= 0,
        user_type_priority: !!this.user_type.user_type_priority,
        employee_flg: [0,1].indexOf(this.user_type.employee_flg) >= 0,
        business_type_content: !!this.user_type.business_type_content,

        not_input: !!this.user_type.user_type_name &&
                   [1, 2, 3, 4, 5].indexOf(this.user_type.default_user_authority) >= 0 &&
                   !!this.user_type.user_type_priority &&
                   [0,1].indexOf(this.user_type.employee_flg) >= 0 &&
                   !!this.user_type.business_type_content
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getQuestions () {
      let data = {}
      let res = await this.$store.dispatch('GET_QUESTION_ALL', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.questions = res.questions
      this.getQuestionEnd = true
    },
    onClickSave: function () {
      if (this.savingFlag) return false
      this.canValidate = true
      if (this.isValid) {
        this.savingFlag = true
        console.log("is valid")
        this.$store.dispatch('USER_TYPE_CREATE',
          { data: this.user_type, callback: this.onSaved })
      }else{
        console.log("need edit")
      }
    },
    half: function () {
      this.user_type.user_type_name = utils.emHalf(this.user_type.user_type_name)
    },
    halfBusiness: function () {
      this.user_type.business_type_content = utils.emHalf(this.user_type.business_type_content)
    },
    onClickCancel: function () {
      this.$router.push({ path: '/user_types', query: { type: this.$router.currentRoute.query.type}})
    },
    onSaved: function (result) {
      this.savingFlag = false
      this.$router.push('/user_types')
    },
    contentCounter: function() {
      this.halfBusiness()
      this.contentCount = this.user_type.business_type_content.length
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/usertype-new.js